import { render, staticRenderFns } from "./annotate_canvas.vue?vue&type=template&id=806e3cb2&scoped=true&"
import script from "./annotate_canvas.vue?vue&type=script&lang=js&"
export * from "./annotate_canvas.vue?vue&type=script&lang=js&"
import style0 from "./annotate_canvas.vue?vue&type=style&index=0&id=806e3cb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806e3cb2",
  null
  
)

export default component.exports